var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 6.5H14.625C10.075 6.5 6.5 10.075 6.5 14.625V24.375C6.5 28.925 10.075 32.5 14.625 32.5H24.375C28.925 32.5 32.5 28.925 32.5 24.375V14.625C32.5 10.075 28.925 6.5 24.375 6.5ZM30.0625 24.375C30.0625 27.4625 27.4625 30.0625 24.375 30.0625H14.625C11.5375 30.0625 8.9375 27.4625 8.9375 24.375V14.625C8.9375 11.5375 11.5375 8.9375 14.625 8.9375H24.375C27.4625 8.9375 30.0625 11.5375 30.0625 14.625V24.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13C15.925 13 13 15.925 13 19.5C13 23.075 15.925 26 19.5 26C23.075 26 26 23.075 26 19.5C26 15.925 23.075 13 19.5 13ZM19.5 23.5625C17.225 23.5625 15.4375 21.775 15.4375 19.5C15.4375 17.225 17.225 15.4375 19.5 15.4375C21.775 15.4375 23.5625 17.225 23.5625 19.5C23.5625 21.775 21.775 23.5625 19.5 23.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.3125C19.9487 20.3125 20.3125 19.9487 20.3125 19.5C20.3125 19.0513 19.9487 18.6875 19.5 18.6875C19.0513 18.6875 18.6875 19.0513 18.6875 19.5C18.6875 19.9487 19.0513 20.3125 19.5 20.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e0aa241d35b42e69bf533985107750c4.svg";
export { ForwardRef as ReactComponent };